import { render, staticRenderFns } from "./shouGangPrice.vue?vue&type=template&id=103776fa&scoped=true&"
import script from "./shouGangPrice.vue?vue&type=script&lang=js&"
export * from "./shouGangPrice.vue?vue&type=script&lang=js&"
import style0 from "./shouGangPrice.vue?vue&type=style&index=0&id=103776fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103776fa",
  null
  
)

export default component.exports